import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    favedArticles: {},
    favedShops: {},
    trackingAllowed: false,
    cookieConsented: false
  },
  mutations: {
    AddFavedArticle(state, favedArticle) {
      Vue.set(state.favedArticles, `${favedArticle.id}`, favedArticle);
      console.log(state.favedArticles);
    },
    DeleteFavedArticle(state, favedArticle) {
      Vue.delete(state.favedArticles, `${favedArticle.id}`);
    },
    AddFavedShop(state, favedShop) {
      Vue.set(state.favedShops, `${favedShop.id}`, favedShop);
    },
    DeleteFavedShop(state, favedShop) {
      Vue.delete(state.favedShops, `${favedShop.id}`);
    },
    trackingAllowed(state, trackingAllowed) {
      state.trackingAllowed = trackingAllowed;
    },
    cookieConsented(state, cookieConsented) {
      state.cookieConsented = cookieConsented;
    }
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      paths: ["favedArticles", "favedShops", "trackingAllowed","cookieConsented"]
    })
  ]
});
